import * as React from 'react';

import * as Images from 'pos/Images';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Content, Header, PosScreen, UserButton } from 'pos/ui';
import { AvailableUserDTO, Res, Permission } from 'core/api';
import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { RestaurantFacade } from 'pos/facades';
import { Modal } from 'core/ui-next/modal';
import { VStack, Text, Grid, Box } from '@chakra-ui/react';

type Props = { users: AvailableUserDTO[]; openerUserName: string } & Modal.Actions<AvailableUserDTO>;

function SelectUsersScreen(props: Props) {

	const { users, cancel, openerUserName, close } = props;

	const onSelectUser = (user: AvailableUserDTO) => close(user);

	const getOpenerUser = () => users.find(u => u.Name === openerUserName);

	const selectedUserRef = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		selectedUserRef.current?.scrollIntoView({ block: 'center', inline: 'center' });
	}, []);

	return <PosScreen screenId='CHANGE_TICKET_OPENER' size='medium'>
		<Header title={Res.Web.CHANGE_TICKET_OPENER_USER()} image={Images.ChangeTicketOpenerUser} onClose={cancel} />
		<Content>
			<VStack w='full' paddingY={'6'} paddingX={'12'} gap={'6'} height={'full'}>
				<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.CHANGE_TICKET_OPENER_USER_SELECTION_LBL()}</Text>
				<Grid w='full' justifyContent={'center'} columnGap={'1'} rowGap={'9'} templateColumns={'repeat(auto-fill, 6rem)'} overflow={'auto'}>
					{users.map(user => {
						const isSelected = getOpenerUser() === user;
						return (
							<Box key={user.Id} ref={isSelected ? selectedUserRef : undefined}>
								<UserButton user={user} selected={isSelected} onSelect={() => onSelectUser(user)} />
							</Box>
						);
					})}
				</Grid>
			</VStack>
		</Content>
	</PosScreen >;
}


declare global {
	interface CommandType {
		changeTicketOpener: () => Promise<Result>
	}
}

Command.register('changeTicketOpener', Preconditions.ensure(Permission.Ticket_ChangeOpenerUser), async (): Promise<Result> => {
	const users = await RestaurantFacade.getAvailableUsers();
	const openerUserName = SalesStore.getTicket().OpenerUser;
	const selectedUserResult = await Modal.show(SelectUsersScreen, { users, openerUserName });

	if (!selectedUserResult.ok)
		return Result.error();

	await SalesStore.changeTicketOpenerUser(selectedUserResult.value);

	return Result.ok();
});